import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import StandardButton from "../../../../../components/StandardButton";
import NewColors from "../../../../../themes/NewColors";
import EmptyStateCard from "../../../../../components/EmptyStateCard";
import useEvents from "../../../../../hooks/useEvents";

type EmptyProcessedVideosProps = {
  onRefreshVideos?: () => void;
  onSeeProcessedVideos?: () => void;
  totalVideosCount?: number;
};

const EmptyProcessedVideos = ({ 
  onRefreshVideos,
  onSeeProcessedVideos,
  totalVideosCount = 0 
}: EmptyProcessedVideosProps) => {
  const events = useEvents();
  
  return (
    <Box data-testid="EmptyProcessedVideosView" style={{ margin: 24 }}>
      <EmptyStateCard
        text={
          totalVideosCount > 0
            ? "Hooray! You've processed all shared videos. Great work staying on top of your client feedback!"
            : "No videos to process right now. Check back later as clients share new videos for review."
        }
        background={NewColors.status.success}
      />
      <Box
        style={{
          marginTop: 24,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Stack style={{ maxWidth: 500 }}>
          <Typography style={{ textAlign: "center", marginBottom: 16 }}>
            {totalVideosCount > 0
              ? `You've successfully reviewed all ${totalVideosCount} shared videos. You can view processed videos in individual client summaries or refresh to check for new submissions.`
              : "Your clients haven't shared any videos yet. Encourage them to share exercise videos for form checks and progress tracking through the mobile app."}
          </Typography>
          {(onSeeProcessedVideos || onRefreshVideos) && (
            <StandardButton
              data-testid="EmptyProcessedVideosView-Button"
              variant="primary"
              onClick={() => {
                if (onSeeProcessedVideos) {
                  onSeeProcessedVideos();
                } else if (onRefreshVideos) {
                  onRefreshVideos();
                }
                events.logButtonClick({
                  buttonName: onSeeProcessedVideos
                    ? "See Processed Videos"
                    : "Refresh Videos",
                  pageName: "Shared Videos",
                  tabName: "Empty Processed",
                });
              }}
              style={{ fontSize: 18 }}
            >
              See Processed Videos
            </StandardButton>
          )}
        </Stack>
      </Box>
    </Box>
  );
};

export default EmptyProcessedVideos;